export const InstalmentStatus = Object.freeze({
    VALIDATED: 'V',
    ABORTED: 'A',
    CANCELLED: 'C',
});

const InstalmentPlanStatus = Object.freeze({
    VALIDATED: 'V',
    TERMINATED: 'T',
    ABORTED: 'A',
});

export const FINISHED_INSTALMENT_PLAN_STATUSES = Object.freeze([
    InstalmentPlanStatus.VALIDATED,
    InstalmentPlanStatus.TERMINATED,
    InstalmentPlanStatus.ABORTED,
]);
